import React from 'react';
import './Button.scss';

type Variant = 'primary' | 'secondary' | 'danger' | 'ghost';
type Size = 'sm' | 'md';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
  size?: Size;
  icon?: React.ReactNode;
  marginRightAuto?: boolean;
  loading?: boolean;
}

const Button: React.FC<ButtonProps> = ({
  variant = 'secondary',
  size = 'sm',
  icon,
  marginRightAuto,
  loading = false,
  className,
  children,
  disabled,
  ...rest
}) => {
  const classes = [
    'btn',
    `btn--${variant}`,
    size === 'md' ? 'btn--md' : '',
    marginRightAuto ? 'btn--margin-right-auto' : '',
    loading ? 'btn--loading' : '',
    className ?? '',
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <button className={classes} disabled={disabled || loading} aria-busy={loading} {...rest}>
      {loading ? (
        <span className="btn__dots" aria-hidden>
          <span className="btn__dot" />
          <span className="btn__dot" />
          <span className="btn__dot" />
        </span>
      ) : (
        <>
          {icon}
          {children}
        </>
      )}
    </button>
  );
};

export default Button;
